import * as THREE from 'three'
import TWEEN from '@tweenjs/tween.js'
import { randIntSpread } from '@/utils/random'
import { times } from '@/utils'

/* eslint-disable */
const defaultSettings = {
  width: 500,    // width of area (x)
  depth: 100,    // depth of area (z)
  range: 12,     // variation in waves
  segments: 10,  // number of curves
  amplitude: 10, // tidal amplitude
  period: 5000,  // tidal period
  waves: []      // wave layers
}
/* eslint-enable */

// Creates a random 2D curve along the x-z plane.
function createCurve (length, range, segments) {
  const step = length / segments
  const points = times(segments + 1, i => {
    const x = i * step
    const z = randIntSpread(range)
    return new THREE.Vector3(x, 0, z)
  })

  return new THREE.CatmullRomCurve3(points)
}

export default class Sea extends THREE.Object3D {
  name = 'Sea'

  constructor (settings) {
    super()

    this.settings = Object.assign({}, defaultSettings, settings)

    this.init()
    this.cycle()
  }

  init () {
    const { width, depth, range, segments, waves } = this.settings

    const curve = createCurve(width, range, segments)
    const points = curve.getSpacedPoints(1000)
    const geometry = new THREE.PlaneGeometry(1, 1, 1, 1000)

    points.reverse().forEach(({ x, y, z }, i) => {
      geometry.vertices[2 * i].set(x, y, z)
      geometry.vertices[2 * i + 1].set(x, y, depth)
    })

    // TODO: use buffer geometries
    // var bufferGeometry = new THREE.BufferGeometry().fromGeometry(geometry);

    this.waves = waves.map(({ color, offset }, index) => {
      const material = new THREE.MeshBasicMaterial({ color })
      const wave = new THREE.Mesh(geometry, material)
      wave.position.z = offset
      wave.position.y = index * 0.1
      return wave
    })

    this.waves.reverse().forEach(wave => this.add(wave))
  }

  cycle () {
    const { amplitude, period } = this.settings

    this.waves.forEach((wave, index) => {
      const low = wave.position.z
      const high = low - amplitude
      const duration = period - (0.05 * index * period)
      const delay = period - duration

      const rise = new TWEEN.Tween(wave.position)
        .to({ z: high }, duration)
        .delay(delay)
        .easing(TWEEN.Easing.Back.InOut)

      const fall = new TWEEN.Tween(wave.position)
        .to({ z: low }, duration)
        .delay(delay)
        .easing(TWEEN.Easing.Back.InOut)

      rise.chain(fall)
      fall.chain(rise)

      rise.start()
    })
  }
}
